// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ColumnHeightOutlinedSvg from "@ant-design/icons-svg/es/asn/ColumnHeightOutlined";
import AntdIcon from '../components/AntdIcon';

var ColumnHeightOutlined = function ColumnHeightOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ColumnHeightOutlinedSvg
  }));
};

ColumnHeightOutlined.displayName = 'ColumnHeightOutlined';
export default React.forwardRef(ColumnHeightOutlined);